module.exports = __webpack_public_path__ + "img/567x600px-Melyepites.cab6e430.jpg";